import * as React from 'react';
import { StyleSheet, css, CSSProperties } from 'aphrodite/no-important';
import { CardCaptionContainer, CARD_CAPTION_CONTAINER_TYPES } from '../../CardCaptionContainer';
import { DecorationLine } from '../../DecorationLine';
import { ConditionalVideoWrap } from '../../ConditionalVideoWrap';
import { VrLineHeight } from '../../../../theming/verticalRhythm/verticalRhythm';
import { WrapperForSafariBorderRadiusBug } from '../WrapperForSafariBorderRadiusBug';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { Image } from '../../image/Image';
import { Thumbnail } from '../../image/image.types';
import { Link } from '../../link/Link';

export enum DIVIDED_CARD_TYPES {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export interface CardComponentDataProps {
  id: string | number
  title: string
  articleUrl: string
  image: Thumbnail
  authorName?: string | undefined
  coverType?: string
  showDecorationLine?: boolean
  numberOfLines?: number
}

interface DividedCardComponentThemeProps {
  surfaceStyle: CSSProperties
  cardBackgroundColor: string
  cardTextColor: string
  vrLineHeight?: VrLineHeight | null
}

interface Orientation {
  dividedCardType: 'HORIZONTAL' | 'VERTICAL'
}

type Props = CardComponentDataProps & DividedCardComponentThemeProps & Orientation;

const getHorizontalCardSmallScreenHeight = (vrLineHeight: VrLineHeight | null) => {
  return vrLineHeight
    ? {
      height: `${vrLineHeight![MEDIA_BREAKPOINTS.SMALL] * 4}px`,
    }
    : '';
};

export class DividedCardComponent extends React.Component<Props> {
  createCardStyles(cardBackgroundColor: string, cardTextColor: string, vrLineHeight: VrLineHeight | null) {
    return StyleSheet.create({
      text: {
        overflow: 'hidden',
      },
      dividedCard: {
        width: '100%',
        height: '100%',
        textDecoration: 'none',
        color: cardTextColor,
        backgroundColor: cardBackgroundColor,
        '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
      },
      [DIVIDED_CARD_TYPES.HORIZONTAL]: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
        [MEDIA_BREAKPOINTS.SMALL]: getHorizontalCardSmallScreenHeight(vrLineHeight),
      },
      [DIVIDED_CARD_TYPES.VERTICAL]: {
        display: 'inline-block',
      },
    });
  }

  render() {
    const { title, image, articleUrl, coverType, dividedCardType, numberOfLines = 2, cardBackgroundColor, cardTextColor, surfaceStyle, showDecorationLine = false, vrLineHeight = null } = this.props;
    const cardStyles = this.createCardStyles(cardBackgroundColor, cardTextColor, vrLineHeight);
    return (
      <WrapperForSafariBorderRadiusBug surfaceStyle={surfaceStyle}>
        <Link
          className={css(
            cardStyles.dividedCard,
            cardStyles[dividedCardType],
            StyleSheet.create({ surfaceStyle }).surfaceStyle,
          )}
          href={articleUrl}
        >
          <ConditionalVideoWrap shouldWarp={coverType === 'video'}>
            <Image {...image} lazyLoad />
          </ConditionalVideoWrap>
          {showDecorationLine ? <DecorationLine /> : null}
          <CardCaptionContainer numberOfLines={numberOfLines} type={CARD_CAPTION_CONTAINER_TYPES[dividedCardType]}>
            <h3 className={css(cardStyles.text)}>
              {title}
            </h3>
          </CardCaptionContainer>
        </Link>
      </WrapperForSafariBorderRadiusBug>

    );
  }
}
